/**
 * EGBassPresets - the genres of /bass-guitar (request 04.11.2026: «виртуальная
 * бас-гитара для разных жанров от блюза до дэт-метала, можно соединить с
 * электрогитарами и ещё барабаны»).
 *
 * The same schema as EGPresets (eg-presets.js) with three differences:
 *   bass  - the instrument: model (eg-core MODELS, fam 'bass'), pickup, tuning
 *           (eg-core TUNINGS b4* / b5*), tone, pluck position (mm from the
 *           bridge) and technique (eg-core TECH: finger / pick);
 *   band  - who plays with the bass: `guitar` is an /electric-guitar preset
 *           (its guitar, tuning and rig become the band's guitar) - the
 *           drums and the guitar's part follow the groove (eg-jam.js);
 *   riff  - a bass line in the tab notation of eg-presets (string 1 = the
 *           highest; a four-string's E is 4, a five-string's B is 5).
 * Rigs: the bass amps and cabinets of eg-rig.js (svt / b15 / hifi;
 * 810 / 115 / 410t / off = DI), the bass drive `bg` (clean lows + driven
 * highs, blended - the parallel rig of modern metal bass).
 * `trim` levels the presets: each preset's riff through its own rig, RMS to
 * -14 dB (measured in the browser - see docs/why/bass-guitar.md).
 */
(function (root, factory) {
    var api = factory();
    if (typeof globalThis !== 'undefined') globalThis.EGBassPresets = api;
    if (typeof window !== 'undefined') window.EGBassPresets = api;
}(this, function () {
    'use strict';

    function R(bpm, beats, notes, opt) { return Object.assign({ bpm: bpm, beats: beats, notes: notes }, opt || {}); }
    // a bar of the same note in eighths: [beat, string, fret, len, flags]
    function eighths(b0, s, f, flags, n) {
        var out = [];
        for (var i = 0; i < (n || 8); i++) out.push([b0 + i * 0.5, s, f, 0.45, flags || '']);
        return out;
    }
    var off = { on: false };

    var P = [
        {
            id: 'blues', group: 'clean', hue: 220,
            bass: { model: 'bass', sel: 'p', tuning: 'bass4', tone: 0.55, vol: 1, pickMm: 150, tech: 'finger', sympathy: 0.3 },
            pedals: { comp: { on: true, sustain: 0.35, level: 0.55 }, wah: off, boost: off, drive: off },
            amp: { model: 'b15', gain: 0.4, bass: 0.6, mid: 0.55, treble: 0.42, presence: 0.35, master: 0.55, res: 0.35 },
            cab: { type: '115', mic: 0.5 }, mod: off, delay: off,
            reverb: { on: true, type: 'room', decay: 0.35, mix: 0.08 }, gate: -80, trim: -4.7,
            jam: { groove: 'shuffle', bpm: 96, key: 'E', scale: 'blues', prog: [['I7', 2], ['IV7', 1], ['I7', 1]] },
            band: { guitar: 'blues-rock' },
            riff: R(96, 8, [
                [0, 4, 0, 0.6], [0.667, 4, 4, 0.3], [1, 3, 2, 0.6], [1.667, 3, 4, 0.3], [2, 3, 5, 0.6], [2.667, 3, 4, 0.3], [3, 3, 2, 0.6], [3.667, 4, 4, 0.3],
                [4, 3, 0, 0.6], [4.667, 3, 4, 0.3], [5, 2, 2, 0.6], [5.667, 2, 4, 0.3], [6, 2, 5, 0.6], [6.667, 2, 4, 0.3], [7, 2, 2, 0.6], [7.667, 3, 4, 0.3]
            ])
        },
        {
            id: 'soul', group: 'clean', hue: 30,
            bass: { model: 'bass', sel: 'p', tuning: 'bass4', tone: 0.42, vol: 1, pickMm: 140, tech: 'finger', sympathy: 0.2 },
            pedals: { comp: { on: true, sustain: 0.4, level: 0.55 }, wah: off, boost: off, drive: off },
            amp: { model: 'b15', gain: 0.38, bass: 0.62, mid: 0.6, treble: 0.38, presence: 0.3, master: 0.55, res: 0.3 },
            cab: { type: '115', mic: 0.45 }, mod: off, delay: off,
            reverb: { on: true, type: 'plate', decay: 0.3, mix: 0.06 }, gate: -80, trim: -2.8,
            jam: { groove: 'soul', bpm: 104, key: 'A', scale: 'mixolydian', prog: [['I', 1], ['IV', 1]] },
            band: { guitar: 'clean' },
            riff: R(104, 8, [
                [0, 4, 5, 0.9], [1.5, 4, 5, 0.4], [2, 3, 7, 0.4], [2.75, 3, 9, 0.2], [3, 2, 7, 0.9],
                [4, 3, 5, 0.9], [5.5, 3, 5, 0.4], [6, 2, 7, 0.4], [6.75, 2, 9, 0.2], [7, 1, 7, 0.9]
            ])
        },
        {
            id: 'funk', group: 'clean', hue: 60,
            bass: { model: 'mm', sel: 'h', tuning: 'bass4', tone: 0.9, vol: 1, pickMm: 120, tech: 'finger', sympathy: 0.15 },
            pedals: { comp: { on: true, sustain: 0.6, level: 0.6 }, wah: { on: true, mode: 'auto', sens: 0.3, pos: 0.4 }, boost: off, drive: off },
            amp: { model: 'hifi', gain: 0.4, bass: 0.62, mid: 0.38, treble: 0.62, presence: 0.55, master: 0.55, res: 0.3 },
            cab: { type: '410t', mic: 0.45 }, mod: off, delay: off,
            reverb: { on: true, type: 'room', decay: 0.25, mix: 0.05 }, gate: -72, trim: 8.3,
            jam: { groove: 'funk', bpm: 100, key: 'E', scale: 'dorian', prog: [['i7', 2], ['IV7', 2]] },
            band: { guitar: 'funk-rock' },
            riff: R(100, 8, [
                [0, 4, 0, 0.2], [0.5, 4, 0, 0.1, 'x'], [0.75, 4, 0, 0.15], [1, 2, 2, 0.2], [1.5, 4, 0, 0.2], [2.25, 3, 2, 0.15], [2.5, 2, 0, 0.2], [3, 2, 2, 0.2], [3.5, 3, 2, 0.2, 'x'], [3.75, 4, 3, 0.2],
                [4, 3, 0, 0.2], [4.5, 3, 0, 0.1, 'x'], [4.75, 3, 0, 0.15], [5, 1, 2, 0.2], [5.5, 3, 0, 0.2], [6.25, 2, 2, 0.15], [6.5, 1, 0, 0.2], [7, 1, 2, 0.2], [7.5, 2, 4, 0.2, 'h']
            ])
        },
        {
            id: 'disco', group: 'clean', hue: 300,
            bass: { model: 'jb', sel: 'nb', tuning: 'bass4', tone: 0.8, vol: 1, pickMm: 110, tech: 'finger', sympathy: 0.1 },
            pedals: { comp: { on: true, sustain: 0.5, level: 0.58 }, wah: off, boost: off, drive: off },
            amp: { model: 'hifi', gain: 0.38, bass: 0.6, mid: 0.45, treble: 0.6, presence: 0.5, master: 0.55, res: 0.3 },
            cab: { type: '410t', mic: 0.5 }, mod: off, delay: off,
            reverb: { on: true, type: 'plate', decay: 0.35, mix: 0.07 }, gate: -76, trim: -3.1,
            jam: { groove: 'disco', bpm: 118, key: 'A', scale: 'dorian', prog: [['i7', 1], ['IV7', 1]] },
            band: { guitar: 'clean' },
            riff: R(118, 8, [
                [0, 4, 5, 0.35], [0.5, 2, 7, 0.35], [1, 4, 5, 0.35], [1.5, 2, 7, 0.35], [2, 4, 5, 0.35], [2.5, 2, 7, 0.35], [3, 4, 5, 0.35], [3.5, 2, 5, 0.35],
                [4, 3, 5, 0.35], [4.5, 1, 7, 0.35], [5, 3, 5, 0.35], [5.5, 1, 7, 0.35], [6, 3, 5, 0.35], [6.5, 1, 7, 0.35], [7, 3, 5, 0.35], [7.5, 3, 7, 0.35]
            ])
        },
        {
            id: 'reggae', group: 'clean', hue: 120,
            bass: { model: 'bass', sel: 'p', tuning: 'bass4', tone: 0.32, vol: 1, pickMm: 230, tech: 'finger', sympathy: 0.2 },
            pedals: { comp: { on: true, sustain: 0.45, level: 0.55 }, wah: off, boost: off, drive: off },
            amp: { model: 'b15', gain: 0.36, bass: 0.72, mid: 0.45, treble: 0.3, presence: 0.25, master: 0.55, res: 0.4 },
            cab: { type: '115', mic: 0.4 }, mod: off, delay: off,
            reverb: { on: true, type: 'spring', decay: 0.35, mix: 0.06 }, gate: -80, trim: -6.1,
            jam: { groove: 'reggae', bpm: 75, key: 'G', scale: 'minor', prog: [['i', 1], ['iv', 1]] },
            band: { guitar: 'clean' },
            riff: R(75, 8, [
                [0, 4, 3, 1.4], [1.5, 4, 3, 0.4], [2.5, 3, 5, 0.4], [3, 3, 1, 0.9],
                [4, 3, 3, 1.4], [5.5, 3, 3, 0.4], [6.5, 2, 5, 0.4], [7, 2, 1, 0.9]
            ])
        },
        {
            id: 'jazz', group: 'clean', hue: 200,
            bass: { model: 'jb', sel: 'n', tuning: 'bass4', tone: 0.6, vol: 1, pickMm: 170, tech: 'finger', sympathy: 0.3 },
            pedals: { comp: { on: false }, wah: off, boost: off, drive: off },
            amp: { model: 'b15', gain: 0.35, bass: 0.58, mid: 0.55, treble: 0.45, presence: 0.35, master: 0.55, res: 0.3 },
            cab: { type: '115', mic: 0.5 }, mod: off, delay: off,
            reverb: { on: true, type: 'room', decay: 0.4, mix: 0.1 }, gate: -80, trim: 2.5,
            jam: { groove: 'swing', bpm: 140, key: 'C', scale: 'major', prog: [['ii7', 1], ['V7', 1]] },
            band: { guitar: 'clean' },
            // walking: a note on every beat, the last one leading to the next chord
            riff: R(140, 8, [
                [0, 3, 5, 0.9], [1, 3, 7, 0.9], [2, 2, 3, 0.9], [3, 2, 4, 0.9],
                [4, 2, 5, 0.9], [5, 2, 3, 0.9], [6, 3, 5, 0.9], [7, 3, 4, 0.9]
            ])
        },
        {
            id: 'classic-rock', group: 'crunch', hue: 18,
            bass: { model: 'bass', sel: 'p', tuning: 'bass4', tone: 0.75, vol: 1, pickMm: 110, tech: 'pick', sympathy: 0.2 },
            pedals: { comp: { on: true, sustain: 0.4, level: 0.55 }, wah: off, boost: off, drive: off },
            amp: { model: 'svt', gain: 0.5, bass: 0.6, mid: 0.55, treble: 0.5, presence: 0.45, master: 0.6, res: 0.35 },
            cab: { type: '810', mic: 0.45 }, mod: off, delay: off,
            reverb: { on: true, type: 'room', decay: 0.3, mix: 0.06 }, gate: -76, trim: -6.8,
            jam: { groove: 'rock8', bpm: 120, key: 'A', scale: 'minpent', prog: [['I5', 2], ['bVII5', 1], ['IV5', 1]] },
            band: { guitar: 'classic-rock' },
            riff: R(120, 8, eighths(0, 4, 5).concat(eighths(4, 4, 3, '', 4)).concat(eighths(6, 3, 5, '', 4)))
        },
        {
            id: 'hard-rock', group: 'drive', hue: 4,
            bass: { model: 'bass', sel: 'p', tuning: 'bass4', tone: 0.85, vol: 1, pickMm: 95, tech: 'pick', sympathy: 0.1 },
            pedals: { comp: { on: true, sustain: 0.45, level: 0.55 }, wah: off, boost: off, drive: { on: true, type: 'bg', drive: 0.3, tone: 0.55, level: 0.55, blend: 0.4 } },
            amp: { model: 'svt', gain: 0.6, bass: 0.62, mid: 0.6, treble: 0.55, presence: 0.5, master: 0.6, res: 0.4 },
            cab: { type: '810', mic: 0.45 }, mod: off, delay: off,
            reverb: { on: true, type: 'room', decay: 0.3, mix: 0.05 }, gate: -70, trim: -7.2,
            jam: { groove: 'rock8b', bpm: 132, key: 'E', scale: 'minpent', prog: [['I5', 2], ['bVI5', 1], ['bVII5', 1]] },
            band: { guitar: 'hard-rock' },
            riff: R(132, 8, eighths(0, 4, 0, '', 6).concat([[3, 4, 3, 0.45], [3.5, 4, 5, 0.45]]).concat(eighths(4, 4, 8, '', 4)).concat(eighths(6, 3, 5, '', 4)))
        },
        {
            id: 'punk', group: 'drive', hue: 330,
            bass: { model: 'bass', sel: 'p', tuning: 'bass4', tone: 0.85, vol: 1, pickMm: 90, tech: 'pick', sympathy: 0.05 },
            pedals: { comp: off, wah: off, boost: off, drive: { on: true, type: 'bg', drive: 0.4, tone: 0.6, level: 0.55, blend: 0.45 } },
            amp: { model: 'svt', gain: 0.62, bass: 0.6, mid: 0.62, treble: 0.58, presence: 0.55, master: 0.6, res: 0.35 },
            cab: { type: '810', mic: 0.4 }, mod: off, delay: off,
            reverb: off, gate: -68, trim: -4.6,
            jam: { groove: 'punk', bpm: 180, key: 'E', scale: 'major', prog: [['I5', 1], ['IV5', 1], ['V5', 1], ['IV5', 1]] },
            band: { guitar: 'punk' },
            riff: R(180, 8, eighths(0, 4, 0, '', 8).concat(eighths(4, 3, 0, '', 4)).concat(eighths(6, 3, 2, '', 4)))
        },
        {
            id: 'grunge', group: 'drive', hue: 36,
            bass: { model: 'bass', sel: 'p', tuning: 'b4dropd', tone: 0.75, vol: 1, pickMm: 100, tech: 'pick', sympathy: 0.15 },
            pedals: { comp: off, wah: off, boost: off, drive: { on: true, type: 'fz', drive: 0.55, tone: 0.45, level: 0.5 } },
            amp: { model: 'svt', gain: 0.55, bass: 0.65, mid: 0.6, treble: 0.5, presence: 0.45, master: 0.6, res: 0.45 },
            cab: { type: '810', mic: 0.45 }, mod: off, delay: off,
            reverb: { on: true, type: 'room', decay: 0.35, mix: 0.06 }, gate: -66, trim: -8.3,
            jam: { groove: 'half', bpm: 100, key: 'D', scale: 'minor', prog: [['I5', 2], ['bIII5', 1], ['IV5', 1]] },
            band: { guitar: 'grunge' },
            riff: R(100, 8, [
                [0, 4, 0, 1.9], [2, 4, 0, 0.45], [2.5, 4, 3, 0.45, 's5'], [3, 4, 5, 0.9],
                [4, 4, 3, 1.9], [6, 4, 5, 0.9], [7, 4, 0, 0.9]
            ])
        },
        {
            id: 'post-punk', group: 'crunch', hue: 150,
            bass: { model: 'bass', sel: 'p', tuning: 'bass4', tone: 0.9, vol: 1, pickMm: 80, tech: 'pick', sympathy: 0.25 },
            pedals: { comp: { on: true, sustain: 0.4, level: 0.55 }, wah: off, boost: off, drive: off },
            amp: { model: 'svt', gain: 0.45, bass: 0.5, mid: 0.6, treble: 0.62, presence: 0.55, master: 0.6, res: 0.3 },
            cab: { type: '410t', mic: 0.45 }, mod: { on: true, type: 'chorus', rate: 0.35, depth: 0.45, mix: 0.4 }, delay: off,
            reverb: { on: true, type: 'hall', decay: 0.45, mix: 0.1 }, gate: -76, trim: 4.6,
            jam: { groove: 'motorik', bpm: 140, key: 'E', scale: 'minor', prog: [['i', 2], ['bVI', 1], ['bVII', 1]] },
            band: { guitar: 'post-punk' },
            // the melody up the neck, an octave over the guitar's root
            riff: R(140, 8, [
                [0, 2, 2, 0.45], [0.5, 2, 2, 0.45], [1, 1, 4, 0.45], [1.5, 1, 2, 0.45], [2, 2, 5, 0.45], [2.5, 2, 4, 0.45], [3, 2, 2, 0.9],
                [4, 2, 2, 0.45], [4.5, 1, 0, 0.45], [5, 1, 2, 0.45], [5.5, 1, 4, 0.45], [6, 1, 5, 0.45], [6.5, 1, 4, 0.45], [7, 1, 2, 0.9]
            ])
        },
        {
            id: 'heavy-metal', group: 'high', hue: 350,
            bass: { model: 'jb', sel: 'b', tuning: 'bass4', tone: 0.85, vol: 1, pickMm: 85, tech: 'pick', sympathy: 0.05 },
            pedals: { comp: { on: true, sustain: 0.5, level: 0.55 }, wah: off, boost: off, drive: { on: true, type: 'bg', drive: 0.45, tone: 0.6, level: 0.55, blend: 0.5 } },
            amp: { model: 'svt', gain: 0.55, bass: 0.62, mid: 0.5, treble: 0.58, presence: 0.55, master: 0.6, res: 0.45 },
            cab: { type: '810', mic: 0.4 }, mod: off, delay: off,
            reverb: { on: true, type: 'room', decay: 0.3, mix: 0.05 }, gate: -62, trim: -2.9,
            jam: { groove: 'gallop', bpm: 168, key: 'E', scale: 'minor', prog: [['I5', 2], ['bVI5', 1], ['bVII5', 1]] },
            band: { guitar: 'heavy-metal' },
            riff: R(168, 8, [
                [0, 4, 0, 0.45, 'pm'], [0.5, 4, 0, 0.22, 'pm'], [0.75, 4, 0, 0.22, 'pm'], [1, 4, 0, 0.45, 'pm'], [1.5, 4, 0, 0.22, 'pm'], [1.75, 4, 0, 0.22, 'pm'],
                [2, 4, 0, 0.45, 'pm'], [2.5, 4, 0, 0.22, 'pm'], [2.75, 4, 0, 0.22, 'pm'], [3, 4, 3, 0.45], [3.5, 4, 1, 0.45],
                [4, 4, 0, 0.45, 'pm'], [4.5, 4, 0, 0.22, 'pm'], [4.75, 4, 0, 0.22, 'pm'], [5, 4, 0, 0.45, 'pm'], [5.5, 4, 0, 0.22, 'pm'], [5.75, 4, 0, 0.22, 'pm'],
                [6, 4, 8, 0.45], [6.5, 4, 8, 0.45], [7, 4, 10, 0.45], [7.5, 4, 10, 0.45]
            ])
        },
        {
            id: 'thrash', group: 'high', hue: 0,
            bass: { model: 'jb', sel: 'b', tuning: 'bass4', tone: 0.95, vol: 1, pickMm: 70, tech: 'pick', sympathy: 0 },
            pedals: { comp: { on: true, sustain: 0.5, level: 0.55 }, wah: off, boost: off, drive: { on: true, type: 'bg', drive: 0.5, tone: 0.7, level: 0.55, blend: 0.5 } },
            amp: { model: 'svt', gain: 0.58, bass: 0.6, mid: 0.45, treble: 0.66, presence: 0.62, master: 0.6, res: 0.45 },
            cab: { type: '810', mic: 0.35 }, mod: off, delay: off,
            reverb: off, gate: -58, trim: -1.2,
            jam: { groove: 'thrash', bpm: 200, key: 'E', scale: 'phrygian', prog: [['I5', 2], ['bII5', 1], ['I5', 1]] },
            band: { guitar: 'thrash' },
            riff: R(200, 8, eighths(0, 4, 0, 'pm', 3).concat([[1.5, 4, 1, 0.45]]).concat(eighths(2, 4, 0, 'pm', 3)).concat([[3.5, 4, 3, 0.45]])
                .concat(eighths(4, 4, 0, 'pm', 3)).concat([[5.5, 4, 6, 0.45], [6, 4, 5, 0.45], [6.5, 4, 3, 0.45], [7, 4, 1, 0.45], [7.5, 4, 0, 0.45]]))
        },
        {
            id: 'stoner-doom', group: 'fuzz', hue: 40,
            bass: { model: 'bass', sel: 'p', tuning: 'b4dropc', tone: 0.7, vol: 1, pickMm: 110, tech: 'pick', sympathy: 0.2 },
            pedals: { comp: off, wah: off, boost: off, drive: { on: true, type: 'fz', drive: 0.7, tone: 0.4, level: 0.5 } },
            amp: { model: 'svt', gain: 0.6, bass: 0.7, mid: 0.62, treble: 0.42, presence: 0.4, master: 0.62, res: 0.55 },
            cab: { type: '810', mic: 0.45 }, mod: off, delay: off,
            reverb: { on: true, type: 'hall', decay: 0.5, mix: 0.1 }, gate: -66, trim: -9.6,
            jam: { groove: 'doom', bpm: 66, key: 'C', scale: 'minpent', prog: [['I5', 2], ['bIII5', 1], ['IV5', 1]] },
            band: { guitar: 'stoner-doom' },
            riff: R(66, 8, [[0, 4, 0, 2.9], [3, 4, 3, 0.9, 's5'], [4, 4, 5, 1.9], [6, 4, 3, 0.9], [7, 4, 0, 0.9]])
        },
        {
            id: 'modern-metal', group: 'high', hue: 280,
            bass: { model: 'b5', sel: 'b', tuning: 'b5', tone: 0.95, vol: 1, pickMm: 75, tech: 'pick', sympathy: 0 },
            pedals: { comp: { on: true, sustain: 0.6, level: 0.58 }, wah: off, boost: off, drive: { on: true, type: 'bg', drive: 0.55, tone: 0.65, level: 0.55, blend: 0.55 } },
            amp: { model: 'hifi', gain: 0.45, bass: 0.62, mid: 0.45, treble: 0.62, presence: 0.6, master: 0.6, res: 0.4 },
            cab: { type: '410t', mic: 0.4 }, mod: off, delay: off,
            reverb: { on: true, type: 'plate', decay: 0.3, mix: 0.05 }, gate: -56, trim: 0.0,
            jam: { groove: 'djent', bpm: 110, key: 'B', scale: 'minor', prog: [['I5', 2], ['bVI5', 1], ['bVII5', 1]] },
            band: { guitar: 'modern-metal' },
            riff: R(110, 8, [
                [0, 5, 0, 0.2, 'pm'], [0.75, 5, 0, 0.2, 'pm'], [1.5, 5, 0, 0.2, 'pm'], [2, 5, 0, 0.2, 'pm'], [2.75, 5, 0, 0.2, 'pm'], [3, 5, 1, 0.9],
                [4, 5, 0, 0.2, 'pm'], [4.75, 5, 0, 0.2, 'pm'], [5.5, 5, 0, 0.2, 'pm'], [6, 5, 3, 0.45], [6.5, 5, 0, 0.2, 'pm'], [7, 5, 5, 0.9]
            ])
        },
        {
            id: 'death-metal', group: 'high', hue: 345,
            bass: { model: 'b5', sel: 'b', tuning: 'b5', tone: 1, vol: 1, pickMm: 70, tech: 'pick', sympathy: 0 },
            pedals: { comp: { on: true, sustain: 0.6, level: 0.58 }, wah: off, boost: off, drive: { on: true, type: 'bg', drive: 0.6, tone: 0.75, level: 0.55, blend: 0.5 } },
            amp: { model: 'svt', gain: 0.55, bass: 0.6, mid: 0.42, treble: 0.7, presence: 0.66, master: 0.6, res: 0.45 },
            cab: { type: '810', mic: 0.35 }, mod: off, delay: off,
            reverb: off, gate: -54, trim: -4.9,
            jam: { groove: 'blast', bpm: 200, key: 'B', scale: 'phrygian', prog: [['I5', 2], ['bII5', 1], ['bV5', 1]] },
            band: { guitar: 'death-metal' },
            // the guitar's tremolo riff, doubled in sixteenths
            riff: R(200, 8, (function () {
                var n = [], line = [[0, 0], [1, 1], [2, 0], [3, 6], [4, 0], [5, 1], [6, 3], [7, 1]];
                line.forEach(function (x) { for (var k = 0; k < 4; k++) n.push([x[0] + k * 0.25, 5, x[1], 0.22]); });
                return n;
            }()))
        },
        {
            id: 'clean', group: 'clean', hue: 210,
            bass: { model: 'bass', sel: 'p', tuning: 'bass4', tone: 0.7, vol: 1, pickMm: 140, tech: 'finger', sympathy: 0.4 },
            pedals: { comp: { on: true, sustain: 0.35, level: 0.55 }, wah: off, boost: off, drive: off },
            amp: { model: 'hifi', gain: 0.35, bass: 0.55, mid: 0.5, treble: 0.5, presence: 0.45, master: 0.55, res: 0.25 },
            cab: { type: 'off', mic: 0.5 }, mod: off, delay: off,
            reverb: { on: true, type: 'plate', decay: 0.4, mix: 0.08 }, gate: -80, trim: 6.7,
            jam: { groove: 'ballad', bpm: 90, key: 'G', scale: 'major', prog: [['I', 1], ['V', 1], ['vi', 1], ['IV', 1]] },
            band: { guitar: 'clean' },
            riff: R(90, 8, [
                [0, 4, 3, 1.4], [1.5, 3, 5, 0.45], [2, 2, 5, 0.9], [3, 3, 5, 0.9],
                [4, 3, 2, 1.4], [5.5, 2, 4, 0.45], [6, 2, 5, 0.9], [7, 3, 5, 0.9]
            ])
        }
    ];

    // the app reads a preset's instrument as `guitar` (one schema for both pages)
    P.forEach(function (p) { p.guitar = p.bass; });

    return {
        VERSION: 1,
        PRESETS: P,
        byId: function (id) { for (var i = 0; i < P.length; i++) if (P[i].id === id) return P[i]; return null; }
    };
}));
